/* 品类页热点图行为 —— 对应 sections/barska-hotspots.liquid
   替掉原站 WordPress 里的 showHotspotInfo() / hideHotspotInfo() 全局函数 +
   onclick 内联属性,改成 disclosure 模式:button[aria-expanded] 控制 panel。

   跟原站的行为差异(都是刻意的):
   - 热点是 <button>,天生可 Tab 聚焦、Enter/Space 触发(原站是 div+onclick,键盘完全用不了)
   - Esc 关闭当前卡并把焦点还给热点
   - 桌面端加载后随机展开一个(照抄原站),但不抢焦点、不滚动页面;移动端不展开
   - 判断移动端用 matchMedia 而不是 UA 里 sniff Mobi|Android(iPad 会被原站误判成桌面)
*/
(function () {
	'use strict';

	var DESKTOP = '(min-width: 901px)';

	function BarskaHotspots(root) {
		this.root = root;
		this.pins = Array.prototype.slice.call(root.querySelectorAll('[data-bhs-pin]'));
		this.panels = Array.prototype.slice.call(root.querySelectorAll('[data-bhs-panel]'));
		if (!this.pins.length) return;
		this.bind();
		this.relocate();
		root.setAttribute('data-bhs-ready', '');
		this.autoOpen();
	}

	BarskaHotspots.prototype.panelFor = function (pin) {
		var id = pin.getAttribute('aria-controls');
		return id ? document.getElementById(id) : null;
	};

	BarskaHotspots.prototype.pinFor = function (panel) {
		return this.pins.filter(function (pin) {
			return pin.getAttribute('aria-controls') === panel.id;
		})[0];
	};

	BarskaHotspots.prototype.closeAll = function () {
		var self = this;
		this.pins.forEach(function (pin) {
			pin.setAttribute('aria-expanded', 'false');
		});
		this.panels.forEach(function (panel) {
			panel.hidden = true;
		});
	};

	BarskaHotspots.prototype.open = function (pin, moveFocus) {
		var panel = this.panelFor(pin);
		if (!panel) return;
		this.closeAll();
		pin.setAttribute('aria-expanded', 'true');
		panel.hidden = false;
		if (moveFocus) {
			// 焦点留在热点上(disclosure 语义),只把关闭按钮挪进 Tab 序列
			pin.focus({ preventScroll: true });
		}
	};

	BarskaHotspots.prototype.close = function (panel, moveFocus) {
		var pin = this.pinFor(panel);
		panel.hidden = true;
		if (pin) {
			pin.setAttribute('aria-expanded', 'false');
			if (moveFocus) pin.focus({ preventScroll: true });
		}
	};

	BarskaHotspots.prototype.bind = function () {
		var self = this;

		this.pins.forEach(function (pin) {
			pin.addEventListener('click', function () {
				var open = pin.getAttribute('aria-expanded') === 'true';
				if (open) {
					var panel = self.panelFor(pin);
					if (panel) self.close(panel, true);
				} else {
					self.open(pin, true);
				}
			});
		});

		this.root.querySelectorAll('[data-bhs-close]').forEach(function (btn) {
			btn.addEventListener('click', function () {
				var panel = btn.closest('[data-bhs-panel]');
				if (panel) self.close(panel, true);
			});
		});

		this.root.addEventListener('keydown', function (event) {
			if (event.key !== 'Escape' && event.key !== 'Esc') return;
			var panel = self.panels.filter(function (p) {
				return !p.hidden;
			})[0];
			if (!panel) return;
			event.stopPropagation();
			self.close(panel, true);
		});
	};

	/* 原站这块 HTML 在正文中段(约 45-55% 处),Shopify 的 page.content 是一整坨、
	   没法在 Liquid 里劈开插 section。所以正文里留一个占位符,
	   把整个 shopify-section 包裹元素搬进去 —— 搬包裹元素而不是内部 div,
	   主题编辑器的 section 选中/滚动定位才不会失效。 */
	BarskaHotspots.prototype.relocate = function () {
		if (this.root.dataset.bhsRelocate !== 'true') return;
		var wrapper = this.root.closest('.shopify-section') || this.root;
		var slot = document.querySelector('[data-barska-hotspots-slot]');
		if (!slot || slot.contains(wrapper)) return;
		slot.replaceWith(wrapper);
		this.root.setAttribute('data-bhs-relocated', '');
	};

	BarskaHotspots.prototype.autoOpen = function () {
		if (this.root.dataset.bhsAutoOpen !== 'true') return;
		if (!window.matchMedia || !window.matchMedia(DESKTOP).matches) return;
		var pin = this.pins[Math.floor(Math.random() * this.pins.length)];
		if (pin) this.open(pin, false);
	};

	function init(scope) {
		(scope || document).querySelectorAll('[data-bhs-root]').forEach(function (root) {
			if (root.dataset.bhsInit) return;
			root.dataset.bhsInit = '1';
			new BarskaHotspots(root);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			init();
		});
	} else {
		init();
	}

	// 主题编辑器里重新加载 section 后要再挂一次
	document.addEventListener('shopify:section:load', function (event) {
		init(event.target);
	});
})();
